import React from "react";
import { Box, Typography, Container, Skeleton, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";

const BlogDetailsSkeleton = () => {
  // Related Posts Skeleton Render
  const relatedPostsSkeletonRender = Array.from({ length: 2 }).map(
    (_, index) => (
      <Box
        key={index}
        sx={{
          height: 350,
          bgcolor: "action.hover",
          p: 3,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Skeleton variant="circular" width={20} height={20} />
          <Skeleton variant="text" width={80} height={24} />
        </Box>
        <Box>
          <Skeleton variant="text" width="100%" height={28} sx={{ mb: 2 }} />
          <Skeleton variant="text" width="60%" height={24} />
          <Skeleton variant="text" width="80%" height={24} />
          <Skeleton variant="text" width={80} height={20} sx={{ mt: 2 }} />
        </Box>
      </Box>
    ),
  );

  return (
    <Box
      sx={{
        direction: "rtl",
        bgcolor: "background.default",
        minHeight: "100vh",
        borderBottom: "1px solid gray",
      }}
    >
      <Container maxWidth="exl">
        {/* Header Skeleton */}
        <Stack sx={{ width: "100%", height: "500px" }} direction={"row"}>
          {/* Header image skeleton */}
          <Box
            sx={{
              height: "100%",
              bgcolor: "action.hover",
              display: "flex",
              alignItems: "flex-end",
              p: 4,
              width: "100%",
            }}
          >
           
          </Box>
          {/* Side Header Skeleton */}
          {/* <Box
            sx={{
              bgcolor: "primary.main",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
              width: "100px",
            }}
          >
            <Skeleton
              variant="rectangular"
              width={2}
              height={200}
              sx={{ bgcolor: "background.paper", opacity: 0.3 }}
            />
          </Box> */}
        </Stack>

        <Grid container spacing={0}>
          {/* Main Content Section Skeleton */}
          <Grid size={{ xs: 12, md: 9 }}>
            <Box
              sx={{
                p: { xs: 3, md: 6, lg: 10 },
                bgcolor: "background.default",
              }}
            >
              {/* title skeleton */}
              <Skeleton variant="text" width="80%" height={48} sx={{ mb: 4 }} />
              <Skeleton variant="text" width="100%" height={24} />
              <Skeleton variant="text" width="95%" height={24} />
              <Skeleton variant="text" width="90%" height={24} />
              <Skeleton variant="text" width="85%" height={24} />
              <Skeleton variant="text" width="70%" height={24} />
              <Skeleton variant="text" width="50%" height={24} sx={{ mt: 2 }} />
            </Box>
          </Grid>
          {/* Sidebar Section Skeleton */}
          <Grid
            size={{ xs: 12, md: 3 }}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            {relatedPostsSkeletonRender}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default BlogDetailsSkeleton;
